module.exports = __webpack_public_path__ + "static/img/anos_90.32b1614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_90.png
// module id = uLKe
// module chunks = 0